module.exports = __webpack_public_path__ + "static/media/ALevel_process.e0b2424a.png";